import React, { useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { ActionIconContainer } from "./TableElements";
import { LinkSpan } from "./form/FormElements";
import { postApi } from "../../api/getUser";
import { Trans, useTranslation } from "react-i18next";

const FreePlanBanner = () => {
  const { t } = useTranslation("common");
  const { setIsFreePlan } = useAuth();
  const handleClose = () => {
    setIsFreePlan(false);
  };

  return (
    <div
      className="d-flex align-items-center justify-content-between w-100"
      style={{
        padding: "5px 10px",
        background: "#E3F2FD",
        border: "1px solid #E3F2FD",
        //borderRadius: "5px",
        zIndex: 100,
        position: "fixed",
        height: "40px",
      }}
    >
      <div style={{ fontWeight: 500 }}>
        <Trans i18nKey="free_plan_msg" t={t} />
      </div>
      <div className="d-flex align-items-center gap-1">
        <ActionIconContainer onClick={handleClose}>
          <i className="fi fi-rr-cross-small" />
        </ActionIconContainer>
      </div>
    </div>
  );
};

export default FreePlanBanner;
